
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import Autosuggest from 'react-autosuggest'
import Input from '../AtomicInput';
import { autoSuggestionItem, autoSuggestionWrapper } from './style'

class AtomicAutoSuggest extends Component {
  constructor() {
    super()

    this.state = {
      value: '',
      suggestions: []
    }

    this.getSuggestionValue = this.getSuggestionValue.bind(this)
    this.renderSuggestion = this.renderSuggestion.bind(this)
    this.renderInputComponent = this.renderInputComponent.bind(this)
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this)
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this)
  }

  getSuggestionValue = (suggestion) => {
    const { suggestionKeyValueToUse } = this.props
    return suggestion[suggestionKeyValueToUse]
  }

  renderSuggestion = (suggestion) => {
    const { suggestionKeyToRender } = this.props

    return (
      <div className={autoSuggestionItem} key={suggestion}>
        {suggestion[suggestionKeyToRender]}
      </div>
    )
  }

  renderInputComponent = inputProps => <Input {...inputProps} />

  onSuggestionsFetchRequested = () => {
    const { suggestions } = this.props

    this.setState({
      suggestions
    })
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    })
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    })
  }

  shouldRenderSuggestions = value => true

  render() {
    const { value: stateValue } = this.state

    const {
      shadow,
      hasError,
      onChange,
      value,
      suggestions,
      renderSuggestion,
      onSuggestionsFetchRequested,
      onSuggestionsClearRequested,
      onSuggestionSelected,
      suggestionKeyToRender,
      suggestionKeyValueToUse,
      shouldRenderSuggestions,
      ...rest
    } = this.props

    const themeStyles = {
      container: 'mainContainer',
      suggestionsList: 'suggestionsList',
      suggestionHighlighted: 'suggestionHighlighted',
      suggestionsContainer: 'suggestionsContainer'
    }

    const inputProps = {
      value: value || stateValue,
      onChange: onChange || this.onChange,
      hasError,
      ...rest
    }

    return (
      <div className={autoSuggestionWrapper(shadow, hasError || false)}>
        <Autosuggest
          theme={themeStyles}
          suggestions={suggestions}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested || this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={onSuggestionsClearRequested || this.onSuggestionsClearRequested}
          onSuggestionSelected={onSuggestionSelected || undefined}
          shouldRenderSuggestions={shouldRenderSuggestions || this.shouldRenderSuggestions}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={renderSuggestion || this.renderSuggestion}
          renderInputComponent={this.renderInputComponent}
          inputProps={inputProps}
        />
      </div>
    )
  }
}

AtomicAutoSuggest.propTypes = {
  /** These are the suggestions that will be displayed. Items can take an arbitrary shape. */
  suggestions: PropTypes.instanceOf(Array).isRequired,
  /** Input onChange function to use */
  onChange: PropTypes.func,
  /** Use your imagination to define how suggestions are rendered. */
  renderSuggestion: PropTypes.func,
  /** Will be called every time you need to recalculate suggestions. */
  onSuggestionsFetchRequested: PropTypes.func,
  /** Will be called every time you need to set suggestions to []. */
  onSuggestionsClearRequested: PropTypes.func,
  /** Will be called every time suggestion is selected via mouse or keyboard. */
  onSuggestionSelected: PropTypes.func,
  /** When the input is focused, Autosuggest will consult this function when to render suggestions. Use it, for example, if you want to display suggestions when input value is at least 2 characters long. */
  shouldRenderSuggestions: PropTypes.func,
  /** Suggestion key to use as value when user selects a suggestion */
  suggestionKeyValueToUse: PropTypes.string,
  /** Suggestion key to show on suggestion list visually, for user selection */
  suggestionKeyToRender: PropTypes.string,
  /** Value to be shown on input when suggestion is selected */
  value: PropTypes.string,
  /** Shadow style of input */
  shadow: PropTypes.bool,
  /** Show on error state */
  hasError: PropTypes.bool
}

AtomicAutoSuggest.defaultProps = {
  onChange: null,
  onSuggestionsFetchRequested: null,
  onSuggestionsClearRequested: null,
  onSuggestionSelected: null,
  shouldRenderSuggestions: null,
  suggestionKeyValueToUse: null,
  suggestionKeyToRender: null,
  renderSuggestion: null,
  value: '',
  shadow: false,
  hasError: false
}

export default AtomicAutoSuggest
